import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import Text from "../../../assets/components/Text"
import BasicButton from "../../../assets/components/BasicButton"
import LinkButton from "../../../assets/components/LinkButton";

import { useContext } from "react";
import { PolyglotContext } from "../../../polyglot/polyGlotContext";


interface UserInfoDialogProps {
    open: boolean;
    closeDialog: () => void;
}

const UserInfoDialog = ({ open, closeDialog }: UserInfoDialogProps) => {
    const { polyglot } = useContext(PolyglotContext)


    return (
        <Dialog
            open={open}
            onClose={closeDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                <Text size="heading" bold>
                    {polyglot.t("admin.userInfoDialog.heading")}
                </Text>
            </DialogTitle>
            <DialogContent>
                <Text size="small">
                    {polyglot.t("admin.userInfoDialog.infoText")}
                </Text>
                <LinkButton
                    label="https://console.firebase.google.com/"
                    url="https://console.firebase.google.com/"
                />
            </DialogContent>
            <DialogActions>
                <BasicButton title={polyglot.t("admin.userInfoDialog.closeDialogBtn")} onClick={closeDialog} />
            </DialogActions>
        </Dialog>
    );
}

export default UserInfoDialog